import { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { AuthRoutes, PublicRoute } from 'app/domains/urls';
import { PageLoader } from 'shared/domains/common-ui';
import { workspaceToDashboardRedirect, workspaceToFilesRedirect, } from './App/screens/Dashboard/utils';
import NotFound from './App/screens/NotFound';
import SettingsRoute from './App/screens/Settings';
const LogoutRoute = lazy(() => import('./Logout'));
const SignupRoute = lazy(() => import('./Signup'));
const CompanyCreationRoute = lazy(() => import('./CompanyCreation'));
const InviteRoute = lazy(() => import('./Invite'));
const VerifyRoute = lazy(() => import('./Verify'));
const DraftRoute = lazy(() => import('./App/screens/Draft'));
const DraftEditorRoute = lazy(() => import('./App/screens/DraftEditor'));
const ContractsRoute = lazy(() => import('./App/screens/Contracts'));
const DashboardRoute = lazy(() => import('./App/screens/Dashboard'));
const InsightsRoute = lazy(() => import('./App/screens/Insights'));
const FilesSystemRoute = lazy(() => import('./App/screens/FileSystem'));
const ExpertRoute = lazy(() => import('./App/screens/Expert'));
const DocumentRoute = lazy(() => import('./App/screens/Document'));
const PlansRoute = lazy(() => import('./App/screens/Plans'));
const CheckoutRoute = lazy(() => import('./App/screens/Checkout'));
const AddCompanyRoute = lazy(() => import('./App/screens/AddCompany'));
const AddCompanyFinishedRoute = lazy(() => import('./App/screens/AddCompanyFinished'));
const SearchRoute = lazy(() => import('./App/screens/Search'));
const UsersTeamsRoute = lazy(() => import('./App/screens/UsersTeams'));
const TeamProfileRoute = lazy(() => import('./App/screens/TeamProfile'));
const IntegrationsRoute = lazy(() => import('./App/screens/Integrations'));
const IntegrationRoute = lazy(() => import('./App/screens/Integration'));
const SharedWithMeRoute = lazy(() => import('./App/screens/SharedWithMe'));
const TasksRoute = lazy(() => import('./App/screens/Tasks'));
const AllDocumentsRoute = lazy(() => import('./App/screens/AllDocuments'));
const AwaitingApprovalsRoute = lazy(() => import('./App/screens/AwaitingApprovalsDocuments'));
const AwaitingSignaturesRoute = lazy(() => import('./App/screens/AwaitingSignaturesDocuments'));
const SharedDocumentsRoute = lazy(() => import('./App/screens/SharedDocuments'));
const Drafts = lazy(() => import('./App/screens/Drafts'));
const UnverifiedTagsRoute = lazy(() => import('./App/screens/UnverifiedTags'));
export function Routes() {
    return (<Suspense fallback={<PageLoader delay={50}/>}>
      <Switch>
        <Redirect from="/sv-se/*" to="/*"/>
        <Redirect exact from="/" to="/dashboard"/>
        <Redirect path="/login" to="/" exact/>

        {/* make sure to edit `isPublicRoute` function if you add/remove public routes */}
        <PublicRoute path="/logout" component={LogoutRoute} exact/>
        <PublicRoute path="/signup" component={SignupRoute} exact/>
        <PublicRoute path="/invite/:id" component={InviteRoute} exact/>
        <PublicRoute path="/company-creation" component={CompanyCreationRoute} exact/>

        <AuthRoutes>
          <Route path="/verify" component={VerifyRoute} exact/>
          <Route path="/plans" component={PlansRoute}/>
          <Route path="/checkout" component={CheckoutRoute}/>
          <Route path="/document/:id" component={DocumentRoute}/>
          <Route exact path="/draft/:id" component={DraftRoute}/>
          <Route exact path="/draft/:id/chapter/:ref" component={DraftEditorRoute}/>
          <Route path="/add-company" component={AddCompanyRoute} exact/>
          <Route path="/add-company/finished" component={AddCompanyFinishedRoute} exact/>
          <Route path="/contracts" component={ContractsRoute}/>
          <Route exact path="/workspaces" render={routeProps => <Redirect to={workspaceToDashboardRedirect(routeProps)}/>}/>
          <Route exact path="/dashboard" component={DashboardRoute}/>
          <Route exact path="/insights" component={InsightsRoute}/>

          <Route path={['/workspaces/:workspaceId/folders/:folderId', '/workspaces/:workspaceId']} render={routeProps => <Redirect to={workspaceToFilesRedirect(routeProps)}/>}/>
          <Route path="/files/:folderId?" component={FilesSystemRoute}/>
          <Route path="/all-documents" component={AllDocumentsRoute}/>
          <Route path="/unverified-tags" component={UnverifiedTagsRoute}/>
          <Route path="/drafts" component={Drafts}/>
          <Route path="/shared-with-me:folderId?" component={SharedWithMeRoute}/>
          <Route exact path="/documents/awaiting-signatures" component={AwaitingSignaturesRoute}/>
          <Route exact path="/documents/awaiting-approvals" component={AwaitingApprovalsRoute}/>
          <Route exact path="/documents/shared" component={SharedDocumentsRoute}/>

          <Redirect exact from="/settings" to="/settings/profile"/>
          <Route path="/settings/:activeTab" component={SettingsRoute}/>
          <Route path="/expert" component={ExpertRoute}/>
          <Route path="/search" component={SearchRoute} exact/>
          <Route path="/users-teams" component={UsersTeamsRoute} exact/>
          <Route path="/users-teams/team/:teamId" component={TeamProfileRoute} exact/>
          <Route path="/integrations" component={IntegrationsRoute} exact/>
          <Route path="/integrations/:id" component={IntegrationRoute} exact/>
          <Route path="/tasks" component={TasksRoute} exact/>
          <Route component={NotFound}/>
        </AuthRoutes>
      </Switch>
    </Suspense>);
}
